import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const Icd11Service = {
  getIcd11List(params: any){ return axiosRequest('GET', API_PATH.ICD11.LIST(params)) },
  getIcd11(data: any){ return axiosRequest('POST', API_PATH.ICD11.INFO, data) },
  addIcd11(data: any){ return axiosRequest('POST', API_PATH.ICD11.ADD, data) },
  deleteIcd11(data: any){ return axiosRequest('POST', API_PATH.ICD11.DELETE, data) },
}